<template lang="pug">
  div(@click="addUnlike").wrap-atom-unlike.f.fm
    v-icon(size="20px" :color="color").mr2 thumb_down_alt
    span(:style="`color: ${color};`").mr2 Bad
    span(:style="`color: ${color};`") {{num}}

</template>

<style lang="scss" scoped>
.wrap-atom-unlike {
  span {
    font-size: 12px;
  }
}
</style>

<script>
import db, { api } from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'

const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  components: {

  },
  computed: {
    ...mapStateAuth([
      'uid'
    ])
  },
  props: {
    cardAuthor: {
      type: String,
      required: true
    },
    postId: {
      type: String,
      required: true
    },
    unlikes: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      color: '#999',
      num: 0
    }
  },
  async created () {
    if (this.unlikes.includes(this.uid)) this.color = '#2a2a2a'
    this.num = this.unlikes.length
  },
  methods: {
    // ...mapActionsTeam([
    //   'loadMemberUsers'
    // ])
    async addUnlike () {
      if (this.color === '#2a2a2a') {
        return false
      }

      if (this.uid) {
        this.color = '#2a2a2a'
        this.num++

        // call API
        const response = await fetch(`${api}/addUnlike`, {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            'uid': this.uid,
            'postId': this.postId,
            'createdBy': this.cardAuthor
          })
        })
        var result = await response.json()
        var res = result.res
        console.log(res)

        db.collection('unlikes').add({
          author: this.uid,
          postId: this.postId,
          createdAt: new Date()
        })
      }
    }
  }
}
</script>
